import type { CcPauseReason } from "@/api/code-companion";

/**
 * A frase que explica uma pausa, por motivo.
 *
 * ⚠️ **Um mapa só, e não um por tela** (2ª rodada da review da #617). O `RunPanel` e o
 * `NeedsAHuman` mantinham cópias, e elas já tinham divergido: a sessão ADT era "expired"
 * num lugar e "dropped" no outro, a pausa manual era "manually" e "by hand". Duas
 * verdades para o mesmo estado é como uma delas fica errada sem ninguém notar, que foi
 * exatamente o que aconteceu quando o motivo novo entrou só num dos lados.
 *
 * 🔶 **Escolhe pelo MOTIVO, nunca pela ação.** Dois motivos podem pedir a mesma coisa
 * (`manual` e `model_unavailable` ambos pedem retomar) e ainda assim precisar de frases
 * distintas, porque a pessoa precisa saber **o que** resolver antes de retomar. Colar os
 * dois eixos foi o que fez um run parado por provedor fora exibir "Paused manually.".
 */
export function pauseMessage(t: (k: string) => string, reason: CcPauseReason | null): string {
  switch (reason) {
    case "no_adt_session":
      return t("The ADT session dropped. Reconnect to continue.");
    case "auth":
      return t("Credentials were refused.");
    case "hitl":
      return t("Waiting for a decision.");
    case "model_unavailable":
      return t("The model provider did not answer. Renew its credential and resume the run.");
    case "manual":
      return t("Paused by hand.");
    default:
      return t("Paused for an unknown reason.");
  }
}
